import { createFileRoute } from "@tanstack/react-router";
import { TutorJoinPage } from "@/components/partners/TutorJoinPage";
import { tutorJoinHead } from "@/components/partners/tutor-join-head";

// «Для репетиторов и кружков» (en). Ссылка — только в подвале сайта.
export const Route = createFileRoute("/en/tutors/join")({
  head: () => tutorJoinHead("en"),
  component: () => <TutorJoinPage lang="en" />,
});
